import { AdminArea } from "../types";

// Simple in-memory cache with 5 minute TTL
interface CacheEntry {
  data: AdminArea[];
  timestamp: number;
}

const cache = new Map<string, CacheEntry>();
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

function getCacheKey(includeAreas: boolean, frontPage: boolean, days?: number): string {
  return `${includeAreas ? '1' : '0'}-${frontPage ? '1' : '0'}-${days ?? 0}`;
}

export function getCachedAdminAreas(includeAreas: boolean, frontPage: boolean, days?: number): AdminArea[] | null {
  const key = getCacheKey(includeAreas, frontPage, days);
  const entry = cache.get(key);

  if (!entry) {
    return null;
  }

  // Check if cache entry is still valid
  const isExpired = Date.now() - entry.timestamp > CACHE_TTL;
  if (isExpired) {
    cache.delete(key);
    return null;
  }

  return entry.data;
}

export function setCachedAdminAreas(includeAreas: boolean, frontPage: boolean, days: number | undefined, data: AdminArea[]): void {
  const key = getCacheKey(includeAreas, frontPage, days);
  cache.set(key, {
    data,
    timestamp: Date.now(),
  });
}

export function clearAdminAreasCache(): void {
  cache.clear();
}
